import {
  AutoComplete,
  DropDownMenu,
  FontIcon,
  MenuItem,
  TableBody,
  TableRow,
  TableRowColumn,
  TextField,
  Toggle,
} from 'material-ui';
import { cyan500, grey500 } from 'material-ui/styles/colors';
import * as React from 'react';
import { styles } from '../styles/draftDetailsStyle';

const css = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  } as React.CSSProperties,

  table: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  } as React.CSSProperties,

  tableRowColumn: {
    width: '120px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  } as React.CSSProperties,

  column: {
    width: '135px',
    textTransform: 'capitalize',
  } as React.CSSProperties,

  dropDown: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    width: '100%',
    flexWrap: 'wrap',
  } as React.CSSProperties,

  dropDownMenu: {
    width: '160px',
    height: '45px',
    margin: '10px 20px 10px 0',
    paddingLeft: '0',
  } as React.CSSProperties,

  schedule: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    width: 'fit-content',
    alignItems: 'flex-end',
    border: 'grey solid 1px',
    borderRadius: '10px',
    margin: '10px',
  } as React.CSSProperties,

  textField: {
    width: '60px',
    padding: '10px',
  } as React.CSSProperties,

  autoWidth: {
    width: 'auto',
  } as React.CSSProperties,

  paddingLeft0: { paddingLeft: '0' } as React.CSSProperties,

  to: { padding: '0 5px' } as React.CSSProperties,
};

interface PartingTimeSelectionProps {
  isPartedGlance: boolean;
  partingSchedule: {
    [k: string]: Array<{ startTime: number; endTime: number }>;
  };
  handlePartingDataChange: (
    day: string,
    index: number,
    startTime: number,
    endTime: number,
  ) => void;
  handleRemoveSlot: (day: string, index: number) => void;
}

interface State {
  selectedDay: string;
  slotsArray: Array<{ startTime: number; endTime: number }>;
  isAllDaysSelected?: boolean;
}

const DAYS = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
];

class PartingTimeSelection extends React.Component<
  PartingTimeSelectionProps,
  State
> {
  constructor(props: PartingTimeSelectionProps) {
    super(props);
    this.state = {
      selectedDay: 'MONDAY',
      slotsArray: this.props.partingSchedule['MONDAY'],
    };
  }

  handleSelectedDayChange = (event: any, index: number, value: string) => {
    this.setState({ ...this.state, selectedDay: value });
  };

  updateAllDays = () => {
    const selectedDayData = this.props.partingSchedule[this.state.selectedDay];
    Object.keys(this.props.partingSchedule).forEach((eachDay) => {
      selectedDayData.forEach((selTime, index) => {
        this.props.handlePartingDataChange(
          eachDay,
          index,
          selTime.startTime,
          selTime.endTime,
        );
      });
    });
  };

  handleTimeChange = (type, event, value) => {
    const index = event.currentTarget.dataset.index;
    let startTime, endTime;
    if (type === 'start') {
      startTime = value;
      endTime = this.props.partingSchedule[this.state.selectedDay][index]
        .endTime;
    }
    if (type === 'end') {
      endTime = value;
      startTime = this.props.partingSchedule[this.state.selectedDay][index]
        .startTime;
    }
    if (startTime <= 24 && endTime <= 24) {
      this.props.handlePartingDataChange(
        this.state.selectedDay,
        index,
        startTime,
        endTime,
      );
    }
    if (this.state.isAllDaysSelected) {
      this.updateAllDays();
    }
  };
  removeSlot = (event) => {
    const index = event.currentTarget.dataset.index;
    if (this.state.isAllDaysSelected) {
      Object.keys(this.props.partingSchedule).forEach((eachDay) => {
        this.props.handleRemoveSlot(eachDay, index);
      });
    } else {
      this.props.handleRemoveSlot(this.state.selectedDay, index);
    }
  };
  addMoreSlot = (e) => {
    const newIndex = this.props.partingSchedule[this.state.selectedDay].length;

    if (this.state.isAllDaysSelected) {
      Object.keys(this.props.partingSchedule).forEach((eachDay) => {
        this.props.handlePartingDataChange(eachDay, newIndex, 0, 0);
      });
    } else {
      this.props.handlePartingDataChange(
        this.state.selectedDay,
        newIndex,
        0,
        0,
      );
    }
  };

  toggleAllDays = (checked) => {
    this.setState({ ...this.state, isAllDaysSelected: checked });
    this.updateAllDays();
  };

  render() {
    const daysElement = [];
    const { partingSchedule, isPartedGlance } = this.props;
    Object.keys(partingSchedule).forEach(function(key) {
      daysElement.push(
        <TableRow>
          <div style={css.table}>
            <TableRowColumn style={css.column}>{key}</TableRowColumn>
            {partingSchedule[key].map((slot) => (
              <TableRowColumn style={css.tableRowColumn}>
                <div>{slot.startTime}:00</div> - <div>{slot.endTime}:00</div>
              </TableRowColumn>
            ))}
          </div>
        </TableRow>,
      );
    });
    return (
      <div style={css.main}>
        <TableBody
          key="partingTimeTableBody"
          displayRowCheckbox={false}
          style={{ ...styles.width100 }}
        >
          {daysElement}
        </TableBody>

        <Toggle
          label="All Days"
          labelPosition="right"
          onToggle={(e, checked) => this.toggleAllDays(checked)}
          style={{ width: '130px' }}
        />

        <div style={css.dropDown}>
          <DropDownMenu
            value={this.state.selectedDay}
            onChange={this.handleSelectedDayChange}
            style={css.dropDownMenu}
          >
            <MenuItem value={null} primaryText={'Day'} />
            {DAYS.map((item) => {
              return (
                <MenuItem
                  value={item}
                  primaryText={item}
                  style={css.paddingLeft0}
                />
              );
            })}
          </DropDownMenu>
          {partingSchedule[this.state.selectedDay].map((slot, key) => (
            <div style={css.schedule}>
              <TextField
                key="startTime"
                value={slot.startTime}
                inputStyle={{ width: '100%' }}
                data-index={key}
                onChange={(e, value) => {
                  this.handleTimeChange('start', e, value);
                }}
                style={css.textField}
                type="number"
                fullWidth={false}
              />
              <p style={css.to}> to </p>
              <TextField
                key="endTime"
                value={slot.endTime}
                name="endTime"
                data-index={key}
                onChange={(e, value) => {
                  this.handleTimeChange('end', e, value);
                }}
                style={css.textField}
                type="number"
                fullWidth={false}
              />
              <FontIcon
                onClick={this.removeSlot}
                data-index={key}
                className="material-icons"
                color={grey500}
                style={{ width: '26px', height: '32px', margin: '0 20px' }}
              >
                delete
              </FontIcon>
            </div>
          ))}
          <FontIcon
            onClick={this.addMoreSlot}
            className="material-icons"
            color={cyan500}
            style={{
              width: '26px',
              height: '48px',
              padding: '0',
              margin: '0 20px',
            }}
          >
            add_box
          </FontIcon>
        </div>
      </div>
    );
  }
}

export default PartingTimeSelection;



// WEBPACK FOOTER //
// ./src/pages/drafts/components/PartingTimeSelection.tsx